export const PLAYFAIR_BOLD = `
  font-family: 'Playfair Display', serif;
  font-weight: 700;
`

export const PLAYFAIR_REGULAR = `
  font-family: 'Playfair Display', serif;
  font-weight: 400;
`

export const PLAYFAIR_BLACK = `
  font-family: 'Playfair Display', serif;
  font-weight: 900;
`

export const LIBRE_REGULAR = `
  font-family: 'Libre Franklin', sans-serif;
  font-weight: 400;
`

export const LIBRE_SEMIBOLD = `
  font-family: 'Libre Franklin', sans-serif;
  font-weight: 600;
`

export const LIBRE_BOLD = `
  font-family: 'Libre Franklin', sans-serif;
  font-weight: 700;
`

export const LIBRE_BLACK = `
  font-family: 'Libre Franklin', sans-serif;
  font-weight: 900;
`

export const ROBOTO_LIGHT = `
  font-family: 'Roboto', sans-serif;
  font-weight: 100;
`

export const ROBOTO_REGULAR = `
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
`

export const ROBOTO_BOLD = `
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
`

export const OPEN_SANS_REGULAR = `
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
`

export const OPEN_SANS_BOLD = `
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
`

export const CANELA_REGULAR = `
  font-family: 'Canela', sans-serif;
  font-weight: 400;
`

export const DM_SERIF_DISPLAY_BOLD = `
  font-family: 'DM Serif Display', sans-serif;
  font-weight: 700;
`

export const DM_SERIF_DISPLAY_REGULAR = `
  font-family: 'DM Serif Display', sans-serif;
  font-weight: 400;
`

export const GEORGIA_REGULAR = `font-family: 'Georgia', serif;`

export const SPECTRAL_REGULAR = `
  font-family: 'Spectral', serif;
  font-weight: 400;
`

export const KARLA_REGULAR = `
  font-family: 'Karla', sans-serif;
  font-weight: 400;
`

export const KARLA_REGULAR_ITALIC = `
  font-family: 'Karla', sans-serif;
  font-weight: 400;
  font-style: italic;
`

export const KARLA_BOLD = `
font-family: 'Karla', sans-serif;
font-weight: 700;
`

export const KARLA_BOLD_ITALIC = `
  font-family: 'Karla', sans-serif;
  font-weight: 700;
  font-style: italic;
`

export const FJALLA_REGULAR = `
  font-family: 'Fjalla One', sans-serif;
  font-weight: 400;
`

export const MONTSERRAT_REGULAR = `
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
`

export const LORA_REGULAR = `
  font-family: 'Lora', serif;
  font-weight: 400;
`

export const TENOR_SANS_REGULAR = `
  font-family: 'Tenor Sans', serif;
`

export const LORA_ITALIC = `
  font-family: 'Lora', serif;
  font-weight: 400;
`

export const RADIANT_REGULAR = `
  font-family: 'Radiant';
  font-weight: 400;
`

export const RAMA_GOTHIC_BOLD = `
  font-family: 'rama-gothic-c';
  font-weight: 700;
`

export const FUTURA_REGULAR = `
  font-family: 'Futura-PT', sans-serif;
  font-weight: 400;
`

export const FUTURA_BOLD = `
  font-family: 'Futura-PT', sans-serif;
  font-weight: 700;
`

export const COOPER_BLACK_REGULAR = `
  font-family: 'cooper-black-std';
  font-weight: 400;
`

export const BRANDON_GROTESQUE_MEDIUM = `
  font-family: 'BrandonGrotesque-Medium';
  font-weight: 400;
`

export const GOPHER_REGULAR = `
  font-family: 'Gopher', sans-serif;
  font-weight: 400;
`

export const GOPHER_MEDIUM = `
  font-family: 'Gopher', sans-serif;
  font-weight: 500;
`

export const GOPHER_BOLD = `
  font-family: 'Gopher', sans-serif;
  font-weight: 700;
`

export const MARGO = `
  font-family: 'Margo', sans-serif;
  font-weight: 500;
`

export const ANTON = `
  font-family: 'Anton', sans-serif;
  font-weight: 400;
`

export const POPPINS_BOLD = `
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
`

export const POPPINS_REGULAR = `
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
`
